'use client';

import { formInputArea } from '@lib/form/helper';
import { InputArea } from '@tuic/web-compositions/shared/InputArea';

import type { AnyFieldApi } from '@tanstack/react-form';
import type { FC, ReactNode } from 'react';

export type ManifestInputAreaFieldProps = {
  field: AnyFieldApi;
  label?: ReactNode;
  note?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  maxChar?: number;
};

export const ManifestInputAreaField: FC<ManifestInputAreaFieldProps> = ({
  field,
  label,
  note,
  required,
  disabled,
  className,
  placeholder,
  maxChar = 55,
}) => (
  <InputArea
    {...formInputArea(field)}
    label={label}
    note={note}
    required={required ? 'label' : undefined}
    disabled={disabled}
    className={className}
    placeholder={placeholder}
    maxChar={maxChar}
  />
);
